import { render, staticRenderFns } from "./registerEntry_blc.vue?vue&type=template&id=22bc5824&scoped=true"
import script from "./registerEntry_blc.vue?vue&type=script&lang=js"
export * from "./registerEntry_blc.vue?vue&type=script&lang=js"
import style0 from "./registerEntry_blc.vue?vue&type=style&index=0&id=22bc5824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bc5824",
  null
  
)

export default component.exports